module.exports = __webpack_public_path__ + "src/img/artist/work08_3.jpg?aeba831cee6fa3256accde7752dd70df";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work08_3.jpg
// module id = 162
// module chunks = 0